<template>
    <div class="wrap-document">
        <div class="page" v-for="(platform, i) in dataPrint.platform" :key="i">
            <p class="title">PERNYATAAN BERTANGGUNG JAWAB ATAS KODE AKSES TRANSAKSI NASABAH (<i>Personal Access Password</i>)</p>
            <div class="content">
                <p>Saya yang bertandatangan di bawah ini:</p>
                <div class="format-text">
                    <label>Nama</label> : <span>{{ dataPrint.fullname }}</span>
                </div>
                <div class="format-text">
                    <label>Tempat/Tanggal Lahir</label> : <span>{{ dataPrint.tempat_lahir }}, {{ dataPrint.tanggalLahir | formatDate }}</span>
                </div>
                <div class="format-text">
                    <label>Alamat</label> : <span>{{ dataPrint.alamat }}</span>
                </div>
                <div class="format-text">
                    <label>NIK</label> : <span>{{ dataPrint.ktp }}</span>
                </div>
                <div class="format-text">
                    <label>
                        No ACC
                    </label>
                    : <span>{{ dataPrint.no_ac }}</span>
                </div>
                <p>
                    Dengan ini menyatakan bahwa saya bertanggungjawab sepenuhnya terhadap kode akses transaksi Nasabah (<i>Personal Access Password</i>) dan tidak
                    menyerahkan kode akses transaksi Nasabah (<i>Personal Access Password</i>) ke pihak lain, terutama kepada pegawai Pialang Berjangka atau pihak
                    yang memiliki kepentingan dengan Pialang Berjangka.
                </p>
            </div>

            <div class="persetujuan">
                <div></div>
                <div class="wrap-signature">
                    <div class="tanggal">{{ dataPrint.tempat_ttd }}, {{ currentDate | formatDateTime }}</div>
                    <div>Yang membuat pernyataan</div>
                    <img :src="dataPrint.tandaTangan" alt="" class="tanda-tangan" />
                    <p style="text-transform: capitalize">{{ dataPrint.fullname }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fullName: String,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
        };
    },
    mounted() {
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
};
</script>

<style scoped>
label {
    width: 9rem;
}

.format-text {
    text-transform: capitalize;
    display: flex;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.wrap-document {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
}

.tanda-tangan {
    width: 100%;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0 auto 40px;
    font-size: 14px;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
}
/* 
form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
} */

.penutup {
    text-align: center;
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
}

.wrap-signature {
    text-align: center;
    width: 30%;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 80%;
    bottom: 0;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .page {
        padding: 0;
    }

    .title {
        margin: 20px auto !important;
    }
}
</style>
